angular.module('gym.components').directive('contactWalletSection', function() {
  return {
    restrict: 'EA',
    scope: {
      gym: '=',
      contact: '=',
      permissions: '=',
      paymentMethods: '=',
      secondProviderPaymentMethods: '=',
      filteredPaymentMethods: '=',
      filteredSecondProviderPaymentMethods: '=',
      alternatePaymentMethod: '=',
      reloadPaymentMethods: '&',
      setTab: '&'
    },
    template: require('templates/components/contacts/wallet/contact_wallet_section.html.slim'),
    controller: ["$scope", "$modal", "$window", "$timeout", "$document", "flash", "loadingAnimation", "PaymentDetailsSharingService", "ContactWalletService", "Contacts", "MessageService", "MasqueradingService", "AdminUserService", function($scope, $modal, $window, $timeout, $document, flash, loadingAnimation, PaymentDetailsSharingService, ContactWalletService, Contacts, MessageService, MasqueradingService, AdminUserService) {
      var getPaymentAccount, getPaymentMethods, removePaymentMethod, sendDefaultPaymentMethod, setDefaultPaymentMethod, unlinkContactPaymentMethod;
      $scope.adminHasPermission = AdminUserService.has;
      $scope.getFilteredPaymentMethods = function(provider) {
        switch (provider) {
          case $scope.gym.payment_system:
            return $scope.filteredPaymentMethods;
          case $scope.gym.secondary_payment_system:
            return $scope.filteredSecondProviderPaymentMethods;
        }
      };
      getPaymentMethods = function(provider) {
        switch (provider) {
          case $scope.gym.payment_system:
            return $scope.paymentMethods;
          case $scope.gym.secondary_payment_system:
            return $scope.secondProviderPaymentMethods;
        }
      };
      getPaymentAccount = function(provider) {
        switch (provider) {
          case $scope.gym.payment_system:
            return $scope.gym.payment_system_account;
          case $scope.gym.secondary_payment_system:
            return $scope.gym.secondary_payment_system_account;
        }
      };
      $scope.displayAddPaymentMethodLink = function(provider) {
        var ba, cc;
        cc = $scope.gym.credit_card_provider;
        ba = $scope.gym.bank_account_provider;
        switch (false) {
          case cc !== ba:
            return 'Payment Method';
          case provider !== ba:
            return 'Bank Account';
          case provider !== cc:
            return 'Credit Card';
        }
      };
      $scope.displayPaymentDetails = function(provider) {
        var isActive, totalLength;
        isActive = (function() {
          switch (provider) {
            case 'ezidebit':
              return $scope.gym.uses_ezidebit;
            case 'stripe':
              return $scope.gym.uses_stripe;
            case 'gocardless':
              return $scope.gym.uses_gocardless;
          }
        })();
        if (!isActive) {
          return;
        }
        totalLength = $scope.filteredPaymentMethods.length + $scope.filteredSecondProviderPaymentMethods.length;
        return $scope.getFilteredPaymentMethods(provider).length || (!totalLength && provider === $scope.gym.payment_system);
      };
      $scope.addEzidebitPaymentMethod = function() {
        return PaymentDetailsSharingService.getSharingOption($scope.contact, getPaymentMethods('ezidebit')).then(function(sharingOption) {
          var modalInstance;
          modalInstance = $modal.open({
            template: require('templates/gyms/contacts/payment_details/ezidebit_payment_details_modal.html.slim'),
            controller: "AddEzidebitPaymentDetailsCtrl",
            resolve: {
              contact: function() {
                return $scope.contact;
              },
              gym: function() {
                return $scope.gym;
              },
              customer: function() {
                return getPaymentMethods('ezidebit').getList();
              },
              paymentAccount: function() {
                return getPaymentAccount('ezidebit');
              },
              sharingOption: function() {
                return sharingOption;
              }
            }
          });
          return modalInstance.result.then(function() {
            return $scope.reloadPaymentMethods();
          });
        });
      };
      $scope.addStripePaymentMethod = function() {
        var modalInstance;
        modalInstance = $modal.open({
          template: require('templates/gyms/contacts/payment_details/stripe_payment_details_modal.html.slim'),
          controller: "AddStripePaymentDetailsCtrl",
          resolve: {
            contact: function() {
              return $scope.contact;
            },
            gym: function() {
              return $scope.gym;
            },
            paymentAccount: function() {
              return getPaymentAccount('stripe');
            },
            customer: function() {
              return getPaymentMethods('stripe').getList();
            }
          }
        });
        return modalInstance.result.then(function() {
          return $scope.reloadPaymentMethods();
        });
      };
      $scope.addGoCardlessPaymentMethod = function() {
        var message, modalInstance;
        if (!$scope.contact.gocardless_ready) {
          message = 'Mandates are currently disabled while your GoCardless account is being verified.';
          MessageService.message({
            title: 'Action unavailable',
            message: message
          });
          return;
        }
        modalInstance = $modal.open({
          template: require('templates/gyms/contacts/payment_details/gocardless_payment_details_modal.html.slim'),
          controller: "AddGoCardlessPaymentMethodCtrl",
          resolve: {
            contact: function() {
              return $scope.contact;
            },
            gym: function() {
              return $scope.gym;
            },
            redirectUrl: function() {
              return $scope.contact.all('gocardless').doPOST({}, 'generate_redirect_flow');
            }
          }
        });
        return modalInstance.result.then(function() {
          return angular.noop;
        }, function(result) {
          var ref;
          if ((ref = result.data) != null ? ref.error : void 0) {
            return flash.error = result.data.error;
          }
        });
      };
      $scope.viewOtherMandatesLinkVisible = function() {
        return $scope.gym.bank_account_provider === 'gocardless' && _.find($scope.paymentMethods, function(item) {
          return !item.show_in_wallet;
        });
      };
      $scope.showOtherMandates = function() {
        return $scope.setTab({
          tab: 'mandates'
        });
      };
      $scope.setDefaultPaymentMethod = function(paymentMethod, provider) {
        var allPaymentMethods, currentDefault, ref;
        allPaymentMethods = [].concat($scope.paymentMethods, $scope.secondProviderPaymentMethods);
        currentDefault = allPaymentMethods.find(function(pm) {
          return pm.default;
        });
        if (((ref = currentDefault.all_contacts) != null ? ref.length : void 0) > 1) {
          return PaymentDetailsSharingService.getSharingOption($scope.contact, [currentDefault], provider).then(function(sharingOption) {
            return setDefaultPaymentMethod(paymentMethod, sharingOption.updateThisContactOnly);
          });
        } else {
          if ($window.confirm('Are you sure you want to set this payment method as default?')) {
            return setDefaultPaymentMethod(paymentMethod, false);
          } else {
            return $timeout(function() {
              return paymentMethod.default = false;
            });
          }
        }
      };
      setDefaultPaymentMethod = function(paymentMethod, updateThisContactOnly) {
        loadingAnimation.show();
        paymentMethod.default = true;
        paymentMethod.rootObjectName = 'payment_method';
        return sendDefaultPaymentMethod(paymentMethod, updateThisContactOnly).then(function() {
          loadingAnimation.hide();
          $scope.reloadPaymentMethods();
          return flash.success = 'Default payment method set successfully';
        }, function() {
          loadingAnimation.hide();
          return flash.error = 'Could not set the default method';
        });
      };
      sendDefaultPaymentMethod = function(paymentMethod, updateThisContactOnly) {
        if (updateThisContactOnly) {
          return paymentMethod.doPUT(paymentMethod, 'unlink_and_update');
        } else {
          return paymentMethod.customPUT(paymentMethod);
        }
      };
      $scope.removePaymentMethod = function(paymentMethod, provider) {
        var ref;
        if (((ref = paymentMethod.all_contacts) != null ? ref.length : void 0) > 1) {
          return unlinkContactPaymentMethod(paymentMethod, provider);
        } else {
          return ContactWalletService.confirmRemovePaymentMethod(paymentMethod).then(function(params) {
            loadingAnimation.show();
            return removePaymentMethod(paymentMethod, params).then(function() {
              loadingAnimation.hide();
              return $scope.reloadPaymentMethods();
            }, function() {
              loadingAnimation.hide();
              return flash.error = 'Could not delete the payment method';
            });
          });
        }
      };
      $scope.removeEzidebitLinkAvailable = function() {
        var allItems, ezidebitItems;
        if (!MasqueradingService.isMasquerading()) {
          return;
        }
        allItems = $scope.paymentMethods.concat($scope.secondProviderPaymentMethods);
        ezidebitItems = allItems.filter(function(item) {
          return item.type === 'ezidebit_customer_detail';
        });
        return ezidebitItems.length && _.every(ezidebitItems, function(item) {
          return item.customer_ref && !item.last4;
        });
      };
      $scope.removeEzidebitLink = function() {
        var allItems, ezidebitItem;
        allItems = $scope.paymentMethods.concat($scope.secondProviderPaymentMethods);
        ezidebitItem = allItems.filter(function(item) {
          return item.type === 'ezidebit_customer_detail';
        })[0];
        return MessageService.message({
          title: 'Remove Link to Ezidebit Customer',
          message: [`This contact is currently linked to an Ezidebit Payer (EzidebitCustomerId: ${ezidebitItem.customer_ref}).`, "Removing this link will allow linking to a new (or different) Ezidebit Payer. Click OK to continue."],
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel'
        }).then(function() {
          return ezidebitItem.customDELETE('clear_ezidebit_link').then(function() {
            return $scope.reloadPaymentMethods();
          });
        });
      };
      removePaymentMethod = function(paymentMethod, params) {
        var reset_customer_ref;
        reset_customer_ref = params.reset_customer_ref ? 1 : void 0;
        return paymentMethod.remove({
          reset_customer_ref: reset_customer_ref
        });
      };
      unlinkContactPaymentMethod = function(paymentMethod, provider) {
        var modalInstance;
        modalInstance = $modal.open({
          template: require('templates/gyms/contacts/payment_details/remove_payment_method.html.slim'),
          controller: 'RemovePaymentMethodCtrl',
          resolve: {
            contact: function() {
              return $scope.contact;
            },
            gym: function() {
              return $scope.gym;
            },
            paymentMethod: function() {
              return paymentMethod;
            },
            provider: function() {
              return provider;
            }
          }
        });
        return modalInstance.result.then(function() {
          return $scope.reloadPaymentMethods();
        });
      };
      return $scope.alternate = function() {
        var availablePaymentMethod, buttonText, currentPaymentMethod;
        currentPaymentMethod = $scope.alternatePaymentMethod.type === 'stripe' ? 'GoCardless Mandate' : 'Stripe credit card';
        availablePaymentMethod = $scope.alternatePaymentMethod.type === 'stripe' ? 'Stripe credit card' : 'GoCardless Mandate';
        buttonText = $scope.alternatePaymentMethod.type === 'stripe' ? 'Switch to Credit Card' : 'Switch to <Mandate';
        return MessageService.message({
          title: 'Switch Payment Method',
          message: [`${$scope.contact.name} is currently processing payments using their ${currentPaymentMethod}, but they also have one or more ${availablePaymentMethod} on file:`, $scope.alternatePaymentMethod.description, `Click \"${buttonText}\" below if you would like to switch to this payment method for all future payments.`],
          confirmButtonText: buttonText,
          cancelButtonText: 'Cancel'
        }).then(function() {
          loadingAnimation.show();
          return Contacts.one(`${$scope.contact.id}`).one($scope.alternatePaymentMethod.type, $scope.alternatePaymentMethod.id).doPUT({}, 'switch_to_alternate').then(function() {
            loadingAnimation.hide();
            return $scope.reloadPaymentMethods();
          }, function() {
            return loadingAnimation.hide();
          });
        });
      };
    }]
  };
});
